import { render, staticRenderFns } from "./Distance.vue?vue&type=template&id=556d00b4"
import script from "./Distance.vue?vue&type=script&lang=js"
export * from "./Distance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556d00b4')) {
      api.createRecord('556d00b4', component.options)
    } else {
      api.reload('556d00b4', component.options)
    }
    module.hot.accept("./Distance.vue?vue&type=template&id=556d00b4", function () {
      api.rerender('556d00b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/Distance.vue"
export default component.exports